// Game search dropdown logic
const searchInput = document.getElementById('enhanced-game-search');
const searchBtn = document.querySelector('.search-btn');
const dropdown = document.getElementById('game-search-dropdown');
  
// List of games and handles (from collections)
const games = window.games || [];

let focusedIndex = -1;

function showDropdown(matches) {
  if (!matches.length) {
    dropdown.innerHTML = '<div style="padding:16px; color:#E0B36A; text-align:center;">No games found.</div>';
    dropdown.style.display = 'block';
    positionDropdown();
    focusedIndex = -1;
    return;
  }
  dropdown.innerHTML = matches.map((game, idx) => `
    <div class="game-search-dropdown-item" data-handle="${game.handle}" tabindex="0" data-idx="${idx}">
      ${game.image ? `<img src="${game.image}" alt="${game.title}">` : `<div class="game-search-dropdown-fallback">?</div>`}
      <span>${game.title}</span>
    </div>
  `).join('');
  dropdown.style.display = 'block';
  positionDropdown();
  focusedIndex = -1;
}

function positionDropdown() {
  // Move dropdown to body if not already
  if (dropdown.parentNode !== document.body) {
    document.body.appendChild(dropdown);
  }
  const input = document.getElementById('enhanced-game-search');
  const rect = input.getBoundingClientRect();
  dropdown.style.position = 'absolute';
  dropdown.style.left = rect.left + window.scrollX + 'px';
  dropdown.style.top = rect.bottom + window.scrollY + 'px';
  dropdown.style.width = rect.width + 'px';
  dropdown.style.zIndex = 1050;
}

function hideDropdown() {
  dropdown.style.display = 'none';
    }

function focusDropdownItem(index) {
  const items = dropdown.querySelectorAll('.game-search-dropdown-item');
  if (items.length === 0) return;
  items.forEach((item, i) => {
    if (i === index) {
      item.classList.add('active');
      item.focus();
    } else {
      item.classList.remove('active');
    }
  });
  focusedIndex = index;
}

function clearDropdownFocus() {
  const items = dropdown.querySelectorAll('.game-search-dropdown-item');
  items.forEach(item => item.classList.remove('active'));
  focusedIndex = -1;
}

searchInput.addEventListener('input', function() {
  const val = searchInput.value.trim().toLowerCase();
  if (!val) {
    hideDropdown();
    return;
  }
  const matches = games.filter(game => game.title.toLowerCase().includes(val));
  showDropdown(matches);
});

searchInput.addEventListener('focus', function() {
  const val = searchInput.value.trim().toLowerCase();
  if (!val) {
    hideDropdown();
    return;
  }
  const matches = games.filter(game => game.title.toLowerCase().includes(val));
  showDropdown(matches);
      });
      
document.addEventListener('click', function(e) {
  if (!dropdown.contains(e.target) && e.target !== searchInput) {
    hideDropdown();
  }
});

dropdown.addEventListener('click', function(e) {
  const item = e.target.closest('.game-search-dropdown-item');
  if (item) {
    const handle = item.getAttribute('data-handle');
    if (handle) {
      window.location.href = `/collections/${handle}`;
    }
  }
});

searchBtn.addEventListener('click', function(e) {
  e.preventDefault();
  const val = searchInput.value.trim().toLowerCase();
  if (!val) return;
  const match = games.find(game => game.title.toLowerCase() === val);
  if (match) {
    window.location.href = `/collections/${match.handle}`;
  } else {
    const matches = games.filter(game => game.title.toLowerCase().includes(val));
    if (matches.length === 1) {
      window.location.href = `/collections/${matches[0].handle}`;
    } else {
      showDropdown(matches);
    }
  }
});

searchInput.addEventListener('keydown', function(e) {
  const items = dropdown.querySelectorAll('.game-search-dropdown-item');
  if (dropdown.style.display !== 'block' || items.length === 0) return;
  if (e.key === 'ArrowDown') {
    e.preventDefault();
    if (focusedIndex < items.length - 1) {
      focusDropdownItem(focusedIndex + 1);
    } else {
      focusDropdownItem(0);
    }
  } else if (e.key === 'ArrowUp') {
    e.preventDefault();
    if (focusedIndex > 0) {
      focusDropdownItem(focusedIndex - 1);
    } else {
      focusDropdownItem(items.length - 1);
    }
  } else if (e.key === 'Enter') {
    if (focusedIndex >= 0 && focusedIndex < items.length) {
      items[focusedIndex].click();
    }
  } else if (e.key === 'Escape') {
    hideDropdown();
    clearDropdownFocus();
  }
});

dropdown.addEventListener('keydown', function(e) {
  const items = dropdown.querySelectorAll('.game-search-dropdown-item');
  if (e.key === 'ArrowDown') {
    e.preventDefault();
    if (focusedIndex < items.length - 1) {
      focusDropdownItem(focusedIndex + 1);
    } else {
      focusDropdownItem(0);
    }
  } else if (e.key === 'ArrowUp') {
    e.preventDefault();
    if (focusedIndex > 0) {
      focusDropdownItem(focusedIndex - 1);
    } else {
      focusDropdownItem(items.length - 1);
    }
  } else if (e.key === 'Enter') {
    if (focusedIndex >= 0 && focusedIndex < items.length) {
      items[focusedIndex].click();
    }
  } else if (e.key === 'Escape') {
    hideDropdown();
    clearDropdownFocus();
    searchInput.focus();
  }
});